import { convertFractionToDecimal } from "../utils/formHelper";

const MealPlanner = (app) => {
  /**
   * And or edit a food
   */
  app.post(
    "/meal-planner/handle-food",
    async ({ req, res, flash, api, assert, locals }) => {
      const { body, query } = req;
      const { foodId } = query;
      let { quantityNumber } = body;
      const { name, quantityDescription, measurementsValue, unitOfMeasure } =
        body;

      const { activeUserToRequest } = locals;

      const validationErrors = [
        { value: name, message: "You need to provide the name of the food" },
        {
          value: quantityNumber,
          message:
            "You need to provide the quantity number and quantity description of the food",
        },
        {
          value: quantityDescription,
          message:
            "You need to provide the quantity number and quantity description of the food",
        },
        {
          value: measurementsValue,
          message: "You need to provide the measurements value",
        },
        {
          value: unitOfMeasure,
          message: "You need to provide the unit of measure",
        },
      ];

      for (const { value, message } of validationErrors) {
        assert(value, 400, message);
      }

      quantityNumber = convertFractionToDecimal(quantityNumber);

      const bodyToSend = {
        ...body,
        quantityNumber,
        coachId: activeUserToRequest._id,
      };

      try {
        const method = foodId ? "PUT" : "POST";
        const endpoint = foodId ? `foods/${foodId}` : `foods`;
        const message = foodId ? "updated" : "created";
        await api(endpoint, {
          method,
          body: bodyToSend,
        });

        flash("success", `Food ${message} successfully`);
        res.refreshWith(
          { "modal[type]": "create-meal-planner-food", foodId: "" },
          { url: "back", hash: "#_" }
        );
      } catch (e) {
        flash("error", e.message);
        res.backDontScroll();
      }
    }
  );
  /**
   * Add / edit meals
   */
  app
    .post(
      "/meal-planner/handle-meal",
      async ({ req, res, flash, api, assert, locals }) => {
        const { body, query } = req;
        const { mealId } = query;
        const { activeUserToRequest } = locals;
        const bodyToSend = {
          ...body,
          coachId: activeUserToRequest._id,
        };

        try {
          const method = mealId ? "PUT" : "POST";
          const endpoint = mealId ? `meals/${mealId}` : `meals`;
          const message = mealId ? "updated" : "created";
          await api(endpoint, {
            method,
            body: bodyToSend,
          });

          flash("success", `Meal ${message} successfully`);
          res.refreshWith(
            { "modal[type]": "create-meal-planner-food", mealId: "" },
            { url: "back", hash: "#_" }
          );
        } catch (e) {
          flash("error", e.message);
          res.backDontScroll();
        }
      }
    )
    .post(
      "/meal-planner/create-meal-plan",
      async ({ req, res, flash, api }) => {
        const { body, query } = req;
        const { proxyAthlete } = query;

        try {
          const method = "POST";
          const endpoint = `meal-plan/?proxyAthlete=${proxyAthlete}`;
          const message = "created";
          const request = await api(endpoint, {
            method,
            body,
          });
          const { nutritionPlanId } = body;
          const responseData = await request.json();
          const mealPlanId = responseData?.mealPlanId;
          flash("success", `Meal plan ${message} successfully`);
          res.refreshWith(
            {
              section: "meal-planner",
              plan: nutritionPlanId,
              mealPlan: mealPlanId,
            },
            { url: "back", hash: "#_" }
          );
        } catch (e) {
          flash("error", e.message);
          res.backDontScroll();
        }
      }
    )
    .post(
      "/meal-planner/update-meal-plan",
      async ({ req, res, flash, api }) => {
        const { body, query } = req;
        const { mealPlanId, proxyAthlete } = query;
        try {
          await api(`meal-plan/${mealPlanId}/?proxyAthlete=${proxyAthlete}`, {
            method: "PUT",
            body,
          });

          flash("success", `Meal plan updated successfully`);
          res.refreshWith(
            {
              "modal[type]": "",
              mealPlannerDate: "",
              mealPlannerMeal: "",
              templateId: "",
            },
            { url: "back", hash: "#_" }
          );
        } catch (e) {
          flash("error", e.message);
          res.backDontScroll();
        }
      }
    )
    .post(
      "/meal-planner/copy-to-from-meal-template",
      async ({ req, res, flash, api }) => {
        const { body } = req;

        try {
          await api(`copy-to-from-meal-template`, {
            method: "PUT",
            body,
          });
          flash("success", `Meal plan template updated successfully`);
          res.refreshWith(
            {
              "modal[type]": "",
              templateId: "",
            },
            { url: "back", hash: "#_" }
          );
        } catch (e) {
          flash("error", e.message);
          res.backDontScroll();
        }
      }
    )
    .post(
      "/meal-planner/add-week-meal-plan",
      async ({ req, res, flash, api }) => {
        const { body, query } = req;
        const { mealPlanId, proxyAthlete } = query;
        try {
          await api(
            `add-week-meal-plan/${mealPlanId}/?proxyAthlete=${proxyAthlete}`,
            {
              method: "PUT",
              body,
            }
          );

          flash("success", `Week added successfully`);
          res.refreshWith({}, { url: "back", hash: "#_" });
        } catch (e) {
          flash("error", e.message);
          res.backDontScroll();
        }
      }
    )
    .post("/meal-planner/create-template", async ({ req, res, flash, api }) => {
      const { body } = req;
      try {
        await api(`meal-plan-template`, {
          method: "POST",
          body,
        });

        flash("success", `Meal plan template created successfully`);
        res.refreshWith(
          { "modal[type]": "", mealPlannerDate: "", mealPlannerMeal: "" },
          { url: "back", hash: "#_" }
        );
      } catch (e) {
        flash("error", e.message);
        res.backDontScroll();
      }
    })
    .post(
      "/meal-planner/create-new-template",
      async ({ locals, req, res, flash, api }) => {
        const { body } = req;
        const { activeUserToRequest } = locals;
        const updatedBody = { ...body, coachId: activeUserToRequest._id };
        try {
          await api(`new-empty-meal-plan-template`, {
            method: "POST",
            body: updatedBody,
          });

          flash("success", `Meal plan template created successfully`);
          res.refreshWith({ "modal[type]": "" }, { url: "back", hash: "#_" });
        } catch (e) {
          flash("error", e.message);
          res.backDontScroll();
        }
      }
    )
    /**
     * Add food to a day, reorder custom meals, add custom meals, remove custom meals
     */
    .post(
      "/meal-planner/update-days-meal-plan",
      async ({ req, res, flash, api }) => {
        const { body, query } = req;
        const { mealPlanId, proxyAthlete } = query;
        const { bodyAction } = body;
        const queryParams = `${mealPlanId}/?proxyAthlete=${proxyAthlete}`;
        const endpoint =
          bodyAction === "handle-food"
            ? `handle-meal-to-meal-plan`
            : bodyAction === "handle-day"
            ? "move-duplicate-day-meal-plan"
            : "handle-custom-meal";

        delete body.bodyAction;
        try {
          await api(`${endpoint}/${queryParams}`, {
            method: "PUT",
            body,
          });

          flash("success", `Meal plan updated successfully`);
          res.refreshWith(
            { "modal[type]": "", mealPlannerDate: "", mealPlannerMeal: "" },
            { url: "back", hash: "#_" }
          );
        } catch (e) {
          flash("error", e.message);
          res.backDontScroll();
        }
      }
    )
    /**
     * Add foods to a day and also save it as a meal
     */
    .post(
      "/meal-planner/update-days-meal-plan-and-add-meal",
      async ({ req, res, flash, api, locals }) => {
        const { activeUserToRequest } = locals;
        const { body, query } = req;
        const { mealPlanId, proxyAthlete } = query;
        const queryParams = `${mealPlanId}/?proxyAthlete=${proxyAthlete}`;
        const endpoints = [
          { url: `meals`, method: "POST" },
          { url: `handle-meal-to-meal-plan/${queryParams}`, method: "PUT" },
        ];
        const bodyToSend = {
          ...body,
          coachId: activeUserToRequest._id,
        };
        try {
          await Promise.all(
            endpoints.map(({ url, method }) =>
              api(`${url}`, {
                method,
                body: bodyToSend,
              })
            )
          );

          flash("success", `Meal plan updated successfully`);
          res.refreshWith(
            { "modal[type]": "", mealPlannerDate: "", mealPlannerMeal: "" },
            { url: "back", hash: "#_" }
          );
        } catch (e) {
          flash("error", e.message);
          res.backDontScroll();
        }
      }
    )
    .post(
      "/meal-planner/delete-meal-plan",
      async ({ req, res, flash, api }) => {
        const { query = {} } = req;
        const {
          mealPlanId,
          proxyAthlete = null,
          nutritionPlanId = null,
        } = query;

        try {
          await api(
            `meal-plan/${mealPlanId}?proxyAthlete=${proxyAthlete}&nutritionPlanId=${nutritionPlanId}`,
            {
              method: "DELETE",
            }
          );

          flash("success", "Successfully deleted");
          if (nutritionPlanId) {
            res.refreshWith(
              {
                section: "",
                plan: "",
                mealPlan: "",
                week: "",
                tabView: "plans",
              },
              { url: "back", hash: "#_" }
            );
          } else {
            res.redirect("/coaching-portal/all-templates?owner=coach&tabView=");
          }
        } catch (e) {
          flash("error", e.message);
          res.backDontScroll();
        }
      }
    )
    .post(
      "/meal-planner/delete-week-meal-plan",
      async ({ req, res, flash, api }) => {
        const { query = {} } = req;
        const { mealPlanId, week } = query;
        try {
          await api(`remove-week-meal-plan/${mealPlanId}?week=${week}`, {
            method: "PUT",
          });

          flash("success", "Successfully deleted");
          res.refreshWith({}, { url: "back", hash: "#_" });
        } catch (e) {
          flash("error", e.message);
          res.backDontScroll();
        }
      }
    )
    .post(
      "/meal-planner/remove-foods-of-meal",
      async ({ req, res, flash, api }) => {
        const { body, query } = req;
        const { mealPlanId, proxyAthlete } = query;
        const queryParams = `${mealPlanId}/?proxyAthlete=${proxyAthlete}`;

        try {
          await api(`remove-foods-of-meal/${queryParams}`, {
            method: "PUT",
            body,
          });

          flash("success", `Meal plan updated successfully`);
          res.backDontScroll();
        } catch (e) {
          flash("error", e.message);
          res.backDontScroll();
        }
      }
    )
    .post(
      "/meal-planner/duplicate-day-meal-plan",
      async ({ req, res, flash, api }) => {
        const { body, query } = req;
        const { mealPlanId, proxyAthlete } = query;
        const queryParams = `${mealPlanId}/?proxyAthlete=${proxyAthlete}`;

        try {
          await api(`duplicate-day-meal-plan/${queryParams}`, {
            method: "PUT",
            body,
          });

          flash("success", `Meal plan updated successfully`);
          res.refreshWith(
            {
              "modal[type]": "",
              mealPlannerDate: "",
              mealPlannerMeal: "",
              date: "",
            },
            { url: "back", hash: "#_" }
          );
        } catch (e) {
          flash("error", e.message);
          res.backDontScroll();
        }
      }
    )
    .get(
      "/meal-planner/delete-master-food-library/:_id/:type",
      async ({ req, res, flash, api }) => {
        const { params } = req;
        const { _id, type } = params;

        if (
          process.browser &&
          !confirm(`Are you sure you want to delete this ${type}?`)
        ) {
          return res.backDontScroll();
        }

        const url = type === "food" ? "foods" : "meals";
        try {
          await api(`${url}/${_id}`, {
            method: "DELETE",
          });
          flash("success", "Successfully deleted");

          res.backDontScroll();
        } catch (error) {
          flash("error", error.message);
          res.backDontScroll();
        }
      }
    )
    .post(
      "/meal-planner/duplicate-week-meal-plan",
      async ({ req, res, flash, api }) => {
        const { query = {} } = req;
        const { mealPlanId, week } = query;
        try {
          await api(`duplicate-week-meal-plan/${mealPlanId}?week=${week}`, {
            method: "PUT",
          });

          flash("success", "Successfully duplicated");
          res.refreshWith({}, { url: "back", hash: "#_" });
        } catch (e) {
          flash("error", e.message);
          res.backDontScroll();
        }
      }
    );
};

export default MealPlanner;
